import { render, staticRenderFns } from "./CommissionMenu.vue?vue&type=template&id=0af75289&"
import script from "./CommissionMenu.vue?vue&type=script&lang=js&"
export * from "./CommissionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports